import { sidebarservice } from '../../services'
import { sidebarConstant } from '../constants'

export const getPermissionsByEmailId = () => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            return sidebarservice.getPermissionByEmailId().then(result => {
                dispatch(getPermissionByEmailIdSuccess(result.data.EntityList))
                dispatch(getPermissionMetadataSuccess(result.data.Metadata || {}))
                return resolve(result.data.EntityList)
            },
                error => {
                    return reject(new Error(error?.message || "Failed to fetch permissions"));
                })
        })
    }
}
export const getPermissionByEmailIdSuccess = response => ({
    type: sidebarConstant.GET_EMPLOYEE_PERMISSION_SUCCESS,
    payload: response
})
export const getPermissionMetadataSuccess = response => ({
    type: sidebarConstant.GET_EMPLOYEE_PERMISSION_METADATA,
    payload: response
})